import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { Tooltip } from '../Tooltip';
import { Icon } from '..';

var HelpIcon = function HelpIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "ionicon",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 80a176 176 0 10176 176A176 176 0 00256 80z",
    strokeMiterlimit: "10",
    className: "ionicon-fill-none ionicon-stroke-width"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296",
    strokeLinecap: "round",
    strokeMiterlimit: "10",
    strokeWidth: "28",
    className: "ionicon-fill-none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "250",
    cy: "348",
    r: "20"
  }));
};
/**
 * Icon for more info with tooltip
 */


var MoreInfo = function MoreInfo(_ref) {
  var title = _ref.title,
      textAlignment = _ref.textAlignment,
      placement = _ref.placement,
      props = _objectWithoutProperties(_ref, ["title", "textAlignment", "placement"]);

  return /*#__PURE__*/React.createElement(Tooltip, {
    content: title,
    textAlignment: textAlignment,
    placement: placement
  }, /*#__PURE__*/React.createElement(Icon, Object.assign({
    icon: HelpIcon,
    color: "icon-primary",
    inline: true
  }, props)));
};

export { MoreInfo };